import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Qingchu"
});
const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M20 3.75C28.975 3.75 36.25 11.025 36.25 20C36.25 28.975 28.975 36.25 20 36.25C11.025 36.25 3.75 28.975 3.75 20C3.75 11.025 11.025 3.75 20 3.75ZM25.63 12.5875L20.295 17.9237L14.96 12.5875L12.5937 14.9538L17.9288 20.29L12.5937 25.625L14.96 27.9912L20.295 22.6562L25.63 27.9912L27.9962 25.625L22.6612 20.29L27.9962 14.9538L25.63 12.5875Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var qingchu = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { qingchu as default };
